import './App.css';
import React from 'react';
import Router from './components/router'
import {AxiosLoaderContextProvider} from "./contexts/AxiosLoaderContext";
import {LanguageContextProvider} from "./contexts/LanguageContext";
// import './assets/css/styles.css';
const App = () => {
    return (
        <AxiosLoaderContextProvider>
            <LanguageContextProvider>
                <Router />
            </LanguageContextProvider>
        </AxiosLoaderContextProvider>
    );
};

export default App;
